import React, {Component} from 'react'
import {
    Form,
    FormGroup,
    Label,
    Button,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col,
    InputGroup,
    InputGroupAddon
} from 'reactstrap'
import {
    AvForm,
    AvField,
    AvGroup,
    AvInput,
    AvFeedback
} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {withRouter} from 'react-router-dom'

import createProjectMutation from '../../../queries/server/mutations/create_project'

class ProjectCreateModal extends Component {

    state = {
        project_id_prefix: 'W',
        project_id: '',
        name: '',
        description: '',
        fee_rate: 71
    }

    render() {

        const {isOpen, toggle} = this.props
        const {project_id_prefix, project_id, name, description, fee_rate} = this.state

        return (
            <Mutation mutation={createProjectMutation}>
                {(createProjectMutationFunc, {loading}) => (
                    <Modal isOpen={isOpen}>
                        <AvForm onValidSubmit={() => {
                            createProjectMutationFunc({
                                variables: {
                                    data: {
                                        project_identifier: {
                                            project_id_prefix,
                                            project_id: project_id || null
                                        },
                                        name,
                                        description,
                                        fee_rate
                                    }
                                }
                            })
                                .then(({data}) => {
                                    this.props.history.push(`/projects/${data.createSimpleProject.project_id}`)
                                })
                        }}>
                            <ModalHeader toggle={toggle}>
                                Create Project
                            </ModalHeader>
                            <ModalBody>
                                <Row form>
                                    <Col sm={3}>
                                        <FormGroup>
                                            <Label for="prefix">Prefix*</Label>
                                            <Input
                                                type="select"
                                                name="prefix"
                                                id="prefix"
                                                bsSize="sm"
                                                value={project_id_prefix}
                                                onChange={(evt) => this.setState({project_id_prefix: evt.target.value})}
                                            >
                                                <option value="W">W</option>
                                                <option value="RCD">RCD</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={9}>
                                        <FormGroup>
                                            <Label for="project_id">Project ID</Label>
                                            <Input
                                                type="text"
                                                name="project_id"
                                                id="project_id"
                                                placeholder="Leave blank to auto generate" bsSize="sm"
                                                value={project_id}
                                                onChange={(evt) => this.setState({project_id: evt.target.value})}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <FormGroup>
                                    <AvField
                                        required
                                        label="Name*"
                                        errorMessage="Required"
                                        type="text"
                                        name="name"
                                        id="name"
                                        bsSize="sm"
                                        value={name}
                                        onChange={(evt) => this.setState({name: evt.target.value})}
                                    />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="description">Description</Label>
                                    <Input
                                        type="textarea"
                                        name="description"
                                        id="description"
                                        bsSize="sm"
                                        onChange={(evt) => this.setState({description: evt.target.value})}
                                    />
                                </FormGroup>

                            </ModalBody>
                            <ModalFooter>
                                <Button size="sm" color="success" disabled={loading}>
                                    <FontAwesomeIcon
                                        color="#fff"
                                        icon={loading ? 'spinner' : 'save'}
                                        spin={loading}
                                    />{' '}
                                    {loading ? 'Saving...' : 'Save'}
                                </Button>
                            </ModalFooter>
                        </AvForm>
                    </Modal>
                )}
            </Mutation>
        )
    }

}

ProjectCreateModal = withRouter(ProjectCreateModal)

export default ProjectCreateModal

ProjectCreateModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired
}

